import React, { useState } from 'react';
import '../../../dist/assets/stylesheets/css/recordPatient.css';
import { Icon } from '@iconify/react';
import GlobalOverlayPortal from '../modals/GlobalOverlayPortal';

function CalibrationViewModal(props) {
    const [selectedView, setSelectedView] = useState(0);

    return (
        <GlobalOverlayPortal>
            <div className='modal-container calibration-view'>
                <div className='modal'>
                    <Icon onClick={props.handleClose} icon="ic:round-close" className='close-btn'/>
                    <h1>Calibration View</h1>
                    <div className='button-container'>
                        {props.data.videos.map((el, i) => (
                            <button onClick={() => setSelectedView(i)} className={selectedView === i ? 'selected' : ''}>
                                View {i}
                            </button>
                        ))}
                    </div>
                    {props.data.videos.map((el, i) => (
                        <video key={i} controls muted className={selectedView === i ? 'selected' : ''} src={el}></video>
                    ))}
                </div>
            </div>
        </GlobalOverlayPortal>
    );
}

export default CalibrationViewModal;
